$(document).ready(function() {
  var acCache = {};
  $("#txtBespokePostcode").autocomplete({
    source: function(acrequest,acresponse) {
      //check cache
      var term = acrequest.term;
      if (term in acCache) {
        acresponse(acCache[ term ]);
        return;
      }
      //get via AJAX
      $.ajax({
        url: "//parcel-intelligence.com/cs/api_ac.php",
        data: {
          a: 'AUPostcodeSuburbAutoComplete',
          n: 'odt20.myshopify.com',
          t: '641f0335d016c72eac9db85c55dfd6f5e864d4f9',
          q: term
        },
        dataType: "jsonp",
        success: function(data) {
          acCache[term] = data;
          acresponse(data);
        }
      });
    },
    minLength: 4,
    open: function() {
    },
    close: function() {
    }
  });

  $('#btnBespokeSubmit').on('click',function() {
    var userInput = $('#txtBespokePostcode').val();

    var exp = /^(.+?),(\d{3,4})$/i;
    var ret = exp.exec(userInput);

    var city = ret[1];
    var postcode = ret[2];
    var pcInt = parseInt(postcode);
    var province = "";
    if ((pcInt >= 1000 && pcInt <= 1999) || (pcInt >= 2000 && pcInt <= 2599) || (pcInt >= 2619 && pcInt <= 2899) || (pcInt >= 2921 && pcInt <= 2999)) {
      province = 'NSW';
    } else if ((pcInt >= 200 && pcInt <= 299) || (pcInt >= 2600 && pcInt <= 2618) || (pcInt >= 2900 && pcInt <= 2920)) {
      province = 'ACT';
    } else if ((pcInt >= 3000 && pcInt <= 3999) || (pcInt >= 8000 && pcInt <= 8999)) {
      province = 'VIC';
    } else if ((pcInt >= 4000 && pcInt <= 4999) || (pcInt >= 9000 && pcInt <= 9999)) {
      province = 'QLD';
    } else if (pcInt >= 5000 && pcInt <= 5999) {
      province = 'SA';
    } else if (pcInt >= 6000 && pcInt <= 6999) {
      province = 'WA';
    } else if (pcInt >= 7000 && pcInt <= 7999) {
      province = 'TAS';
    } else {
      province = 'NT';
    }

    var pid = $('#txtBespokeProductID').val();
    var vid = $('.variant-selection__variants').val() || $('#txtBespokeVariantID').val();
    var qty = $('.quantity-input').val();

    var requestObj = {"origin":{"country":null,"postal_code":null,"province":null,"city":"","name":null,"address1":"","address2":"","address3":null,"phone":"","fax":null,"address_type":null,"company_name":""},
                      "destination":{"country":"AU","postal_code":postcode,"province":province,"city":city,"name":null,"address1":null,"address2":"","address3":null,"phone":"","fax":null,"address_type":null,"company_name":""},"items":[
                        {"name":"","sku":"","quantity":qty,"grams":0,"price":0,"vendor":"","requires_shipping":true,"taxable":true,"fulfillment_service":"manual","properties":null,"product_id":pid,"variant_id":vid}
                      ],"currency":"AUD"};

    $('#lblBespokeRate').html('Calculating ...');

    $.ajax({
      type: "POST",
      beforeSend: function(request) {
        request.setRequestHeader("HTTP_X_STORE_NAME", "odt20.myshopify.com");
        request.setRequestHeader("HTTP_X_STORE_TOKEN", "641f0335d016c72eac9db85c55dfd6f5e864d4f9");
      },
      url: "https://parcel-intelligence.com/cs/api_ex.php",
      data: JSON.stringify(requestObj),
      dataType: 'json',
      contentType: 'application/json',
      processData: false,
      success: function(msg) {
        var hasRate = false;
        $('#lblBespokeRate').html('');
        $.each(msg.rates, function(k,rate) {
          $('#lblBespokeRate').html($('#lblBespokeRate').html()+' - '+rate.service_name+': <span style="font-weight:bold;">$'+(rate.total_price/100))+'</span><br />';
          hasRate = true;
        });
        if (!hasRate) {
          $('#lblBespokeRate').html('Unavailable');
        }
      }
    });
  });
});